import { HiddenItemsEndPoints } from "apis/EndPoints/HiddenItemsEndPoints";
import { Network } from "../Network";

export class HiddenItemsService {
  static getProcurementLogHiddenEntries(data = {}) {
    return Network.fetch(
      HiddenItemsEndPoints.getProcurementLogHiddenEntries.url(
        data?.company_id,
        data.id
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HiddenItemsEndPoints.getProcurementLogHiddenEntries.method,
      }
    );
  }

  static restoreProcurementLogHiddenEntries(data = {}) {
    return Network.fetch(
      HiddenItemsEndPoints.restoreProcurementLogHiddenEntries.url(
        data?.company_id,
        data.id
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HiddenItemsEndPoints.restoreProcurementLogHiddenEntries.method,
        body: JSON.stringify(data),
      }
    );
  }

  static deleteProcurementLogHiddenEntries(data = {}) {
    return Network.fetch(
      HiddenItemsEndPoints.deleteProcurementLogHiddenEntries.url(
        data?.company_id,
        data.id
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HiddenItemsEndPoints.deleteProcurementLogHiddenEntries.method,
        body: JSON.stringify(data),
      }
    );
  }

  static procurementLogHideEntry(data = {}) {
    return Network.fetch(
      HiddenItemsEndPoints.procurementLogHideEntry.url(
        data?.company_id,
        data.id
      ),
      {
        headers: {
          "Content-type": "application/json",
          Authorization: data?.code,
          From: data?.loginEmail,
        },
        method: HiddenItemsEndPoints.procurementLogHideEntry.method,
        body: JSON.stringify(data),
      }
    );
  }
}
